export default __webpack_public_path__ + "static/media/132048113_823010018259430_3992483133524571157_n.9586670e.jpg";